/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Instruction_4Inputs */



/**
* | output |
* | --- |
* | "Go to <strong>Help → Offline Activation</strong>" |
*
* @param {Login_Offline_Instruction_4Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_instruction_4 = /** @type {((inputs?: Login_Offline_Instruction_4Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Instruction_4Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Allez dans <strong>Aide → Activation Hors Ligne</strong>")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gehen Sie zu <strong>Hilfe → Offline-Aktivierung</strong>")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai su <strong>Aiuto → Attivazione offline</strong>")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейдите в раздел <strong>Справка → Автономная активация</strong>")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vaya a <strong>Ayuda → Activación sin conexión</strong>")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("前往<strong>帮助 → 离线激活</strong>")
	if (locale === "ja") return /** @type {LocalizedString} */ ("<strong>ヘルプ → オフラインアクティベーション</strong>に移動します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सहायता → ऑफ़लाइन सक्रियण पर जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Acesse <strong>Ajuda → Ativação offline</strong>")
	return /** @type {LocalizedString} */ ("Go to <strong>Help → Offline Activation</strong>")
});